import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddItemTypeModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedItem: "",
  isEdit: false,
  itemData: [],
};

const itemTypeSlice = createSlice({
  name: "itemType",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = itemTypeSlice.actions;

export default itemTypeSlice.reducer;
